import React from 'react'
import { Route } from 'react-router-dom'
import ZoomMaker from '../../gif-maker/components/zoom'
import CreationTool from '../types/creation-tool'
import GifMaker from './gif-maker'
import Upload from './upload'
import Supercut from './supercut'

export const GIF_MAKER = '/create/gifmaker'
export const BACKDROP = '/backdrop'
export const UPLOAD = '/upload'
export const SUPERCUT = '/supercut'

/**
 * Returns the base route based on creation tool.
 * @param type {string} Creation tool type
 * @returns {string}
 */
export const getBasePathFromCreationTool = (type: CreationTool): string => {
    switch (type) {
        case CreationTool.Upload:
            return UPLOAD
        case CreationTool.GifMaker:
            return GIF_MAKER
        case CreationTool.Backdrop:
            return BACKDROP
        case CreationTool.SuperCut:
            return SUPERCUT
    }
}

/**
 * Returns creation tool based on the current path.
 * @param path Current path
 * @returns {string}
 */
export const getCreationToolFromPath = (path = ''): CreationTool => {
    if (path.indexOf(BACKDROP) === 0) {
        return CreationTool.Backdrop
    }
    if (path.indexOf(UPLOAD) === 0) {
        return CreationTool.Upload
    }
    if (path.indexOf(SUPERCUT) === 0) {
        return CreationTool.SuperCut
    }
    return CreationTool.GifMaker
}

const CreationToolsRoute = (props = {}) => (
    <>
        <Route path={GIF_MAKER} render={() => <GifMaker {...props} />} />
        <Route path={BACKDROP} render={({ match }) => <ZoomMaker {...props} match={match} />} />
        <Route path={UPLOAD} render={() => <Upload {...props} />} />
        <Route path={SUPERCUT} render={() => <Supercut {...props} />} />
    </>
)

export default CreationToolsRoute
